import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import FilterBarVerticalContainer from 'FilterBar/FilterBarVertical/FilterBarVerticalContainer.vue';
import { store } from "ltur-state-engine";
var statePromise = import("../Helper/State");
var initializeFilterBarVertical = function () { return __awaiter(void 0, void 0, void 0, function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, statePromise];
            case 1:
                state = _a.sent();
                return [4 /*yield*/, new Promise(function (res) {
                        var unsubscribe = store.subscribe(function () {
                            if (state.checkStateFulfilledForVerticalFilter(store.getState())
                                && state.checkStateFulfilledForGroupQueryOptions(store.getState())) {
                                unsubscribe();
                                res();
                            }
                        });
                    })];
            case 2:
                _a.sent();
                new Vue({
                    render: function (h) { return h(FilterBarVerticalContainer); },
                }).$mount('#filterBarVertical');
                return [2 /*return*/];
        }
    });
}); };
export default initializeFilterBarVertical;
